import { render, staticRenderFns } from "./UploadVideoSearch.vue?vue&type=template&id=0b07bdeb&scoped=true"
import script from "./UploadVideoSearch.vue?vue&type=script&lang=js"
export * from "./UploadVideoSearch.vue?vue&type=script&lang=js"
import style0 from "./UploadVideoSearch.vue?vue&type=style&index=0&id=0b07bdeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07bdeb",
  null
  
)

export default component.exports